export const iconFontAwesomeDesignMarker = (
	<i className="fa-solid fa-marker"></i>
);
